import React from "react";
import styled from "styled-components";
import { withPanelStyle, H2 } from "@appcues/component-library";

import EnterpriseLabel from "components/Common/ProductLabels/EnterpriseLabel.js";

const PromptPanel = withPanelStyle(styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  padding: 20px;
  align-items: center;
`);

const LocalizationPrompt = () => {
  return (
    <PromptPanel>
      <H2>Localization</H2>
      <EnterpriseLabel />
    </PromptPanel>
  );
};

export default LocalizationPrompt;
